import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _excluded = ["className"];
import { List } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { clsx } from 'clsx';
import { forwardRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
function listItemMixins(theme, space) {
  return {
    '& .MuiListItem-gutters': {
      paddingLeft: theme.spacing(space),
      paddingRight: theme.spacing(space),
      '&.MuiListItem-secondaryAction': {
        paddingRight: theme.spacing(space * 2)
      },
      '& .MuiListItemSecondaryAction-root': {
        right: theme.spacing(space),
        '& .MuiIconButton-edgeEnd': {
          marginRight: theme.spacing(-(space / 2))
        }
      }
    }
  };
}
var useStyles = /*#__PURE__*/makeStyles(theme => ({
  root: _objectSpread(_objectSpread({
    maxWidth: '100%'
  }, listItemMixins(theme, 3)), {}, {
    [theme.breakpoints.up('md')]: _objectSpread({}, listItemMixins(theme, 4))
  })
}), {
  name: 'SD-DrawerList'
});
export var DrawerList = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      className
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var styles = useStyles();
  return /*#__PURE__*/_jsx(List, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    component: "div",
    className: clsx(className, styles.root)
  }));
});
if (process.env.NODE_ENV !== "production") DrawerList.displayName = "DrawerList";